export default __webpack_public_path__ + "static/media/pooldeep.688763d6.png";